import SimpleBar from "simplebar-react";
import React, {useEffect, useState} from "react";
import MainLink from "../../Link";

const ucp_get_items = `${MainLink()}api/ucp/get-shop-items`;
const ucp_buy_item = `${MainLink()}api/ucp/buy-item`;
const ucp_put_in_favourites = `${MainLink()}api/ucp/put-in-favourites`;
const ucp_delete_from_favourites = `${MainLink()}api/ucp/delete-from-favourites`;
const ucp_get_favorites = `${MainLink()}api/ucp/get-favourite-items`;

    const ToastMessage = ({ message, onClose }) => {
        useEffect(() => {
            const timer = setTimeout(onClose, 3000);
            return () => clearTimeout(timer);
        }, [onClose]);

        return <div className="toast-message">{message}</div>;
    };

    function ShopSimpleBar() {
        const currentUrl = window.location.href;
        const parsedUrl = new URL(currentUrl);
        const category = parsedUrl.searchParams.get("category");
        const [hoveredIndex, setHoveredIndex] = useState(null);
        const [items, setItems] = useState([]);
        const [favorites, setFavorites] = useState(new Set());
        const [favoriteItems, setFavoriteItems] = useState(new Set());
        const fetchFavorites = async () => {
            try {
                const userId = localStorage.getItem("user-id");
                const userName = localStorage.getItem("user-login");
                const userPassword = localStorage.getItem("user-password");
                const urlWithParams = `${ucp_get_favorites}?user_id=${encodeURIComponent(userId)}&user_name=${encodeURIComponent(userName)}&user_password=${encodeURIComponent(userPassword)}`;
                try {
                    const response = await fetch(urlWithParams, {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                            "Authorization": `Bearer ${localStorage.getItem("jwtToken")}`
                        },
                    });


                    if (!response.ok) {
                        throw new Error(`Ошибка загрузки избранных предметов: ${response.status}`);
                    }

                    const result = await response.json();

                    setFavoriteItems( new Set(result) );
                    if (favoriteItems.length > 0) setFavorites(new Set(favoriteItems.map(item => item.id)));
                    else setFavorites(new Set());

                } catch (error) {
                    setFavorites(new Set());
                }

                // Загружаем все предметы
                const allItemsResponse = await fetch(ucp_get_items, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${localStorage.getItem("jwtToken")}`
                    },
                });

                if (!allItemsResponse.ok) {
                    throw new Error(`Ошибка загрузки всех предметов: ${allItemsResponse.status}`);
                    fetchFavorites()
                }

                const allItems = await allItemsResponse.json();


                setItems(allItems);

            } catch (err) {
                console.error("Ошибка загрузки данных:", err.message);
            }
        };

        useEffect(() => {
            fetchFavorites();
        }, []);

        const toggleFavorite = async (itemId) => {
            const userId = localStorage.getItem("user-id");
            const userName = localStorage.getItem("user-login");
            const userPassword = localStorage.getItem("user-password");

            const body = {
                user_id: userId,
                user_name: userName,
                user_password: userPassword,
                item_id: itemId
            };

            try {
                if (favoriteItems.has(itemId)) {
                    console.log(`Удаляем ${itemId} из избранного`);
                    const response = await fetch(ucp_delete_from_favourites, {
                        method: "PUT",
                        headers: {
                            "Content-Type": "application/json",
                            "Authorization": `Bearer ${localStorage.getItem("jwtToken")}`
                        },
                        body: JSON.stringify(body)
                    });

                    if (!response.ok) {
                        throw new Error(`Ошибка при удалении из избранного: ${response.status}`);
                    }

                    const result = await response.json();
                    favoriteItems.delete(itemId);
                } else {
                    console.log(`Добавляем ${itemId} в избранное`);
                    const response = await fetch(ucp_put_in_favourites, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            "Authorization": `Bearer ${localStorage.getItem("jwtToken")}`
                        },
                        body: JSON.stringify(body)
                    });

                    if (!response.ok) {
                        throw new Error(`Ошибка при добавлении в избранное: ${response.status}`);
                    }

                    const result = await response.json();
                    favoriteItems.add(itemId);
                }

                // Обновление состояния избранных предметов
                setFavorites((prevFavorites) => {
                    const newFavorites = new Set(prevFavorites);
                    if (newFavorites.has(itemId)) {
                        newFavorites.delete(itemId);
                    } else {
                        newFavorites.add(itemId);
                    }
                    return newFavorites;
                });

            } catch (err) {
                console.error("Ошибка при обновлении избранного:", err.message);
            }
        };
        const [toast, setToast] = useState(null);
        const  handleBuyItem = async (item) => {
            const userId = localStorage.getItem("user-id");
            const userName = localStorage.getItem("user-login");
            const userPassword = localStorage.getItem("user-password");

                window.location.href = "/shop/buy?item_id=" + encodeURIComponent(item.id);

        };
        let categories = ["main", "premium", "accessories", "tp", "coupons", "costumes", "weapons", "kits", "boxes", "cabarets", "other"]

        return (
            <SimpleBar className="simplebar-track-shop" style={{ overflowY: "auto" }}>
                <div className="ucp-two-blocks-container ucp-two-blocks-container-shop">
                    {items.length > 0 ? (
                        items
                            .filter(item => category === "main" || categories.indexOf(category) === item.category) // Фильтруем
                            .map((item, index) => (
                                <div
                                    key={index}
                                    className="character-body character-body-shop"
                                    onMouseEnter={() => setHoveredIndex(index)}
                                    onMouseLeave={() => setHoveredIndex(null)}
                                >
                                    <div className="character-body information-container-body-shop">
                                        <img src={"/media/"+item.imgUrl} alt="" />
                                        <button
                                            className={`ucp-button favorites-button ${favoriteItems.has(item.id) ? "active" : ""}`}
                                            onClick={() => toggleFavorite(item.id, index)}
                                        >
                                            {favorites.has(item.id)}
                                        </button>

                                    </div>
                                    <span className="character-description">
                                        {item.name}
                                     </span>
                                    <button
                                        className="ucp-simple-yellow-button character-description-button"
                                        type="button"
                                        onClick={() => handleBuyItem(item)}
                                    >
                                        {hoveredIndex === index ? "КУПИТЬ" : `${item.price} MD`}
                                    </button>
                                </div>
                            ))
                    ) : (
                        <p className="loading-text">Загрузка...</p>
                    )}

                </div>

                {/*{toast && <ToastMessage message={toast} onClose={() => setToast(null)} />}*/}
            </SimpleBar>
        );

    }

    export default ShopSimpleBar;